import { fetcher } from '@commenda/utils';

/** Voids a draft the assignee never sent, so its task is not wedged by the one-in-flight guard. */
export async function discardEnvelope(envelopeId: string): Promise<Response> {
  return fetcher(`e-signature/envelopes/${envelopeId}/discard`, {
    method: 'POST',
  });
}
